module.exports = __webpack_public_path__ + "static/media/email_icon.76d3294f.png";